<script setup lang="ts">
import { maskToClipPath, IMAGE_MASKS } from '../../utils/imageMask'
import type { ImageMaskShape } from '../../types'

defineProps<{
  value: ImageMaskShape
  disabled?: boolean
}>()

const emit = defineEmits<{
  (e: 'update:value', value: ImageMaskShape): void
}>()

const shapeStyle = (mask: ImageMaskShape) => {
  if (mask === 'none') return { borderRadius: '0', clipPath: 'none' }
  if (mask === 'rounded') return { borderRadius: '4px', clipPath: 'none' }
  return { borderRadius: '0', clipPath: maskToClipPath(mask) }
}
</script>

<template>
  <div class="flex items-center gap-0.5">
    <Button
      v-for="mask in IMAGE_MASKS"
      :key="mask"
      type="button"
      size="icon-sm"
      variant="ghost"
      :disabled="disabled"
      :class="
        value === mask ? 'bg-primary/5 text-primary hover:bg-primary/5 hover:text-primary' : 'text-foreground-disabled'
      "
      @click="emit('update:value', mask)"
    >
      <span class="block size-4 bg-current" :style="shapeStyle(mask)" />
    </Button>
  </div>
</template>
